import { groupsApi } from '@/providers/apis/groups/groups';
import { rosterAPI } from '@/providers/apis/roster/roster';
import { copy } from '@/utils/cohort';
import { isEmptyValue, sortByProperty } from '@/utils/utils';
import moment from 'moment';
import { Vue, Component } from 'vue-property-decorator';
import DateRangePicker from 'vue2-daterange-picker';

@Component({
    name: 'organisations',
    components: {
        'date-range-picker': DateRangePicker,
    },
})

export default class Organisations extends Vue {

    // -----------------------------------------------------------------------
    // Properties

    private fieldsItems: any = [
        {
            key: 'index',
            label: 'S.No',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            allowFilter: false,
        },
        {
            key: 'name',
            label: 'Organization Name',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'type',
            label: 'Type',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'code',
            label: 'Code',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'referenceId',
            label: 'Reference Id',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'dateLastModified',
            label: 'Last Updated',
            thClass: 'sticky-position last-Updated custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'studentCount',
            label: 'Students Count',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'teacherCount',
            label: 'Teachers Count',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'otherCount',
            label: 'Others Count',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'classCount',
            label: 'Classes Count',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },

    ];

    private dateRange: any = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: new Date(),
    };

    private isShowDateFilter: boolean = false;

    private searchItem: any = {};

    private orgList: any = [];

    private perPage: number = 10;

    private totalRowCounts: number = 10;

    private currentPage: number = 1;

    private contentType: string = 'school_district';

    private isLoading: boolean = false;

    private limit: number = 10;

    private offset: number = 0;

    private searchTerms: any = {};

    private cohortLevel: any = [];

    private filterList: any = [
        {
            key: 'type',
            label: 'Type',
            thClass: 'sticky-position',
            sortable: true,
        },
        {
            key: 'code',
            label: 'Code',
            thClass: 'sticky-position',
            sortable: true,
        },
        {
            key: 'referenceId',
            label: 'Reference id',
            thClass: 'sticky-position',
            sortable: true,
        },
    ];

    private selectedFilterItem: any = ['index', 'name', 'studentCount',
        'teacherCount', 'otherCount', 'classCount', 'dateLastModified'];

    public get filteredOrgItemList() {
        return this.fieldsItems.filter((item: any) => {
            return this.selectedFilterItem.includes(item.key);
        });
    }

    private isSearched: any = false;
    // -----------------------------------------------------------------------
    // Actions

    public onSelectPage(pageNumber: number) {
        this.orgList = [];
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.districtList();
    }

    public onSearch() {
        this.resetProperties();
        this.districtList();
    }

    public onSelectRow(row: any) {
        row.routePath = this.$route.path;
        this.$emit('onSelectRow', row, 'orgData');
        this.$router.push('/users-rosters/schools');
    }


    // -----------------------------------------------------------------------
    // Hooks

    private created() {
        this.getAcls();
    }

    // ------------------------------------------------------------------------
    // Methods

    private districtList() {
        this.isLoading = true;
        const offset = this.offset;
        const limit = this.limit;
        const searchTerms = this.searchTerms;
        const params: any = {
            offset,
            limit,
            type: this.contentType,
        };
        for (const key in searchTerms) {
            if (Object.prototype.hasOwnProperty.call(searchTerms, key)) {
                const element = searchTerms[key];
                if (!isEmptyValue(element)) {
                    params[key] = element;
                }
            }
        }
        rosterAPI.getOrgsDetails(params).then((data) => {
            this.isLoading = false;
            this.orgList = data.orgs;
            this.totalRowCounts = data.totalCounts;
        });
    }

    private resetProperties() {
        this.orgList = [];
        this.limit = 10;
        this.offset = 0;
        this.currentPage = 1;
    }

    private onSelectFilter(item: any) {
        const filterIndex = this.selectedFilterItem.findIndex((filterItem: any) => filterItem === item.key);
        if (filterIndex === -1) {
            this.selectedFilterItem.push(item.key);
        } else {
            this.selectedFilterItem.splice(filterIndex, 1);
        }
    }

    private showDateFilter() {
        this.isShowDateFilter = true;
        setTimeout(() => {
            const datePick: any = this.$refs.picker as HTMLElement;
            if (datePick) {
                datePick[0].togglePicker(true);
            }
        }, 200);
    }

    private updateValues() {
        this.offset = 0;
        const dataRange = copy(this.dateRange);
        this.searchTerms.modified_at = `${moment(dataRange.startDate).format('YYYY-MM-DD')}`;
        this.onSearch();
    }

    private removeDateFilter() {
        this.isShowDateFilter = false;
        this.dateRange = {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: new Date(),
        };
        this.searchTerms.modified_at = '';
        this.onSearch();
    }

    private dateFormat(classes: any, date: any) {
        if (!classes.disabled) {
            const a = moment(date.getTime()).format('DD MMM YYYY');
            const b = new Date();
            classes.disabled = moment(a).isAfter(b);
        }
        return classes;
    }

    private searchTable(searchText: any, searchKey: any) {
        const that = this;
        if (searchText.length >= 3 || isEmptyValue(searchText)) {
            switch (searchKey) {
                case 'name':
                    this.searchTerms.search_group_name = searchText;
                    break;
                case 'code':
                        this.searchTerms.search_group_code = searchText;
                        break;
                case 'referenceId':
                    this.searchTerms.search_group_sourced_id = '';
                    break;
                default:
                    break;
            }
            if (!that.isSearched) {
                that.isSearched = true;
                setTimeout(() => {
                    that.isSearched = false;
                    that.onSearch();
                }, 1000);
            }
        }
    }

    private removeDate(searchText: any, searchKey: any) {
        switch (searchKey) {
            case 'name':
                this.searchTerms.search_group_name = '';
                this.searchItem.name = '';
                break;
            case 'code':
                this.searchTerms.search_group_code = '';
                this.searchItem.code = '';
                break;
            case 'referenceId':
                this.searchTerms.search_group_sourced_id = '';
                this.searchItem.referenceId = '';
                break;
            default:
                break;
        }
        this.onSearch();
    }

    private getAcls() {
        groupsApi.fetchUserHierarchies().then((hierarchy: any) => {
            sortByProperty(hierarchy[0].levels, 'sequence', 'ASC');
            this.cohortLevel = hierarchy[0].levels;
            if (this.cohortLevel && this.cohortLevel.length > 0) {
                let nextSequence = {};
                let nextSequenceIndex = -1;
                const stateIndex = this.cohortLevel.findIndex((item: any) => item.type === 'state');
                if (stateIndex !== -1) {
                    nextSequence = this.cohortLevel[stateIndex].sequence + 1;
                    nextSequenceIndex = this.cohortLevel.findIndex((item: any) => item.sequence === nextSequence);
                } else {
                    const countryIndex = this.cohortLevel.findIndex((item: any) => item.type === 'country');
                    if (countryIndex !== -1) {
                        nextSequence = this.cohortLevel[countryIndex].sequence + 1;
                        nextSequenceIndex = this.cohortLevel.findIndex((item: any) => item.sequence === nextSequence);
                    }
                }
                if (nextSequenceIndex !== -1) {
                    this.contentType = this.cohortLevel[nextSequenceIndex].type;
                }
            }
            this.districtList();
        });
    }
}
